module.exports = "mutation($code: String!) {\n  increaseReferralCodeUsage(code: $code)\n}\n"